var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrice2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22344 2.27246H16.7333V6.22345H6.22344V2.27246ZM2.27246 6.23242H6.22345V16.7423H2.27246V6.23242ZM37.7274 6.22754H33.7764V16.7374H37.7274V6.22754ZM23.2578 2.27637H33.7677V6.22735H23.2578V2.27637ZM33.7765 33.7764H23.2666V37.7274H33.7765V33.7764ZM33.7764 23.2578H37.7274V33.7677H33.7764V23.2578ZM6.22345 23.2666H2.27246V33.7765H6.22345V23.2666ZM6.23242 33.7764H16.7423V37.7274H6.23242V33.7764Z",
    fill: "#FF985E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice2);
export default __webpack_public_path__ + "static/media/icon-price-2.4c2a027f723f6c66c4216b81c0f2f70b.svg";
export { ForwardRef as ReactComponent };